import React, { useEffect, useState } from "react";
import { Form, Spin, Select, Divider, Input, Row, Col } from "antd";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";

import "./Language.scss";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TextButton from "../../Buttons/TextButton";
import { DEFAULT_TRANSLATION, LANGUAGES } from "../../../constants";
import { getTranslation } from "../../../utils/helper";
import { doLanguageTranslate } from "../../../modules/setting/stores/thunk";

const LanguageSettingsForm = ({ isFetching, setting, handleSubmit }) => {
  const [form] = Form.useForm();
  const [language, setLanguage] = useState("sv");
  const [position, setPosition] = useState("Menu");
  const dispatch = useDispatch();
  const { translate } = useSelector(state => state.setting);

  useEffect(() => {
    if (setting) {
      const languageT = Object.keys(LANGUAGES).includes(setting.systemLanguage) ? setting.systemLanguage : "sv";
      setLanguage(languageT);
      form.setFieldsValue({ ...setting, systemLanguage: languageT });
      if (!setting.translation?.[languageT]) {
        dispatch(
          doLanguageTranslate({
            text: DEFAULT_TRANSLATION,
            to: languageT,
          }),
        );
      }
    }
  }, [setting]);

  useEffect(() => {
    if (translate) {
      const translation = { ...setting.translation };
      translation[language] = translate;
      form.setFieldsValue({ translation });
    }
  }, [translate]);

  const handleOnFinish = async values => {
    const params = { ...values, translation: { ...setting.translation } };
    params.translation = { ...setting.translation };
    const translation = form.getFieldValue("translation");
    params.translation[language] = {
      ...setting.translation?.[language],
      ...translation[language],
    };
    handleSubmit(params);
  };

  const handleResetDefaultTranlation = () => {
    dispatch(
      doLanguageTranslate({
        text: DEFAULT_TRANSLATION,
        to: language,
      }),
    );
  };

  const handlChangeLanguage = value => {
    setLanguage(value);
    form.setFieldsValue({ systemLanguage: value });
    dispatch(doLanguageTranslate({ text: DEFAULT_TRANSLATION, to: value }));
  };

  const handlChangePosition = value => {
    setPosition(value);
    const translation = form.getFieldValue("translation");
    if (!translation[language]?.[value]) {
      const translationT = { ...translation };
      translationT[language] = { ...translation?.[language] };
      translationT[language][value] = DEFAULT_TRANSLATION[value];
      form.setFieldsValue({ translation: translationT });
    }
  };

  return (
    <Spin spinning={isFetching}>
      <div className="SettingsForm LanguageSettingsForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleOnFinish}>
          <div className="FormContent">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={getTranslation(setting, "Settings", "System Language")}
                  name="systemLanguage"
                  rules={[{ required: true, message: "Required" }]}>
                  <Select size="large" onChange={handlChangeLanguage} showSearch optionFilterProp="children">
                    {Object.keys(LANGUAGES).map((key, index) => (
                      <Select.Option key={index} value={key}>
                        {LANGUAGES[key]}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={getTranslation(setting, "Settings", "Position")}>
                  <Select
                    size="large"
                    onChange={handlChangePosition}
                    value={position}
                    showSearch
                    optionFilterProp="children">
                    {Object.keys(DEFAULT_TRANSLATION).map((label, index) => {
                      return (
                        <Select.Option key={index} value={label}>
                          {label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Divider />
            <div className="Translation">
              <div className="title">{getTranslation(setting, "Settings", "Translation")}</div>
              <table>
                <thead>
                  <tr>
                    <td className="English">English</td>
                    <td>{LANGUAGES[language]}</td>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(DEFAULT_TRANSLATION[position] || {}).map((key, index) => {
                    const translation_label = DEFAULT_TRANSLATION[position][key];
                    return (
                      <tr key={index}>
                        <td className={getTranslation(setting, "Settings", "English")}>{translation_label}</td>
                        <td>
                          <Form.Item name={["translation", language, position, key]}>
                            <Input placeholder={translation_label} />
                          </Form.Item>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <Divider />
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <TextButton
                label={getTranslation(setting, "Settings", "Reset Default Translation")}
                onClick={handleResetDefaultTranlation}
              />
              <PrimaryButton
                label={getTranslation(setting, "Common", "Update")}
                htmlType="submit"
                icon={<ReactSVG className="icon" src="/icons/submit.svg" />}
              />
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default LanguageSettingsForm;
